'use strict';

/* globals $, window, ajaxify, document */

// eslint-disable-next-line no-unused-vars
const TMPlus = {};

$(window).on('action:topic.loading', () => {
	require(
		['tmpsession-view', 'components'],
		(view, components) => {
			console.log({ view, components });
			console.log({ ajaxify });
			if (ajaxify.data.posts.length > 0 && ajaxify.data.posts[0].hasOwnProperty('tmpsessionSn')) {
				// Fetch session room
				const posts = components.get('post');

				if (!posts.length) { return; }
				const post = posts.eq(0);
				const content = post.find('[component="post/content"]');
				const container = document.createElement('dev');
				content[0].appendChild(container);
				// console.log({ content });

				view.render({
					container: container,
					sessionSn: ajaxify.data.posts[0].tmpsessionSn,
				});
			}
		}
	);
});

// (function () {
// 	$(window).on('action:topic.loading', () => {
// 		console.log({ ajaxify });
// 		if (ajaxify.data.posts.length > 0 && ajaxify.data.posts[0].hasOwnProperty('tmpsessionSn')) {
// 			// Fetch session room
// 			loadRoom(ajaxify.data.posts[0].tmpsessionSn);
// 		}
// 	});

// 	async function loadRoom(tmpsessionSn) {
// 		if (!tmpsessionSn) { return; }
// 		const room = await TMPlus.sockets.get({ sessionSn: tmpsessionSn });
// 		console.log({ room });
// 		TMPlus.view.load(room);
// 	}
// }());
